import { Injectable } from '@angular/core';

import { AutoCompleteService } from "../../../shared/components/autocomplete/autocomplete.service";
import { gruposMateriaisStorage } from "./data.service";
import { MaterialService } from "../../materiais/material/shared/material.service";
import { materialStorageName } from "../../materiais/material/shared/data.service";

declare var $: any;

@Injectable()
export class GrupoMaterialService {

  constructor(
    private _materialService: MaterialService,
    private _autocompleteService: AutoCompleteService
  ){}

  setSessionStorage(item: any) {
    var object: string = JSON.stringify(item);
    sessionStorage.setItem(gruposMateriaisStorage + '-new', object);
  }

  getSessionStorage() {
    var item: string = sessionStorage.getItem(gruposMateriaisStorage + "-new");
    return JSON.parse(item);
  }

  clearSessionStorage() {
    sessionStorage.removeItem(gruposMateriaisStorage + "-new");
  }

  //others
  getLastCodeNumber(nextCode: string) {
    if (nextCode.length === 1) {
      nextCode = "00".concat(nextCode);
    } else if (nextCode.length === 2) {
      nextCode = "0".concat(nextCode);
    }

    return nextCode;
  }

  returnToOtherForm(otherForm: string, Response: any) {
    var otherFormObject: any;
    if(Response) {
      if (otherForm === materialStorageName) {
        otherFormObject = this._materialService.getSessionStorage();
        if (Response.grupoId) {
          otherFormObject.subgrupo = Response;
        } else {
          otherFormObject.grupo = Response;
        }
        this._materialService.setSessionStorage(otherFormObject);
      }
    }

    this._autocompleteService.clearSessionStorage(gruposMateriaisStorage);

    if (otherForm === materialStorageName) {
      otherFormObject = this._materialService.getSessionStorage();
      if (otherFormObject.id) {
        this._materialService.goToEdit(otherFormObject.id);
      } else {
        this._materialService.goToAdd();
      }
    }
  }

  //select2 para a caonta contabil
  templateResult = (function(state: any, isCreateNew: boolean) {
    var stateReturn: any,
      text: string;

    if (state.loading) {
      stateReturn = state.text;
    } else {
      if (state.id === -1) {
        if (isCreateNew) {
          stateReturn = this._autocompleteService.setNewTagInList(state);
        } else {
          stateReturn = this._autocompleteService.setNoCreateNew(state.text);
        }
      } else {
        if (state.text) {
          text = state.text;
        } else {
          var code: string = '';
          var description: string = '';

          if (state.codigo) {
            code = state.codigo.toString();
            code = this.getLastCodeNumber(code);
            code = code.concat(" - ");
          } else  if (state.codigoGrupo) {
            code = state.codigoGrupo.toString();
            code = this.getLastCodeNumber(code);
            code = code.concat(" - ");
          }
          if (state.descricao) {
            description = state.descricao;
          }

          text = code.concat(description);
        }

        stateReturn = $('<span>' + text + '</span>');
      }
    }

    return stateReturn;
  }.bind(this));
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/grupos-materiais/shared/grupo-material.service.ts
 **/